import DashboardContactUs from "../features/dashboard/contactUs/components/contactUs";

const ContactUs = ()=>{
return(
    <>
    <div className="row">
    <div className="col-1"></div>
    <div className="col-md-8 col-sm-12">
    <DashboardContactUs />
    </div>
    <div className="col-3"></div>
    </div>
    </>
)
};

export default ContactUs;